
import { Placement } from '@post-office/placements-frontend/jsm-assets-app-navbar-data-manager-section';
export default Placement;
